module.exports = __webpack_public_path__ + "assets/img/conversation.25545516.png";